<ng-container *ngIf="dragData">
  <div class="menu__container" (click)="$event.stopPropagation()">
    <div class="menu__title">
      <ng-container *ngIf="!dragData.title; else createProject">
        <span translate>Schedule</span>&nbsp;

        <span class="text-ellipsis">{{ dragData.name }}</span>
      </ng-container>

      <ng-template #createProject>
        <span>{{ dragData.title | translate }}</span>
      </ng-template>
    </div>

    <div class="flex-row row-flex--between">
      <div class="mr-1">
        <span class="menu__label" translate>Start date</span>

        <app-datepicker
          [date]="dropDate"
          [height]="'28px'"
          [hasBackdrop]="true"
          (dateChanged)="updateSelectedDate($event, 'start_date')"></app-datepicker>
      </div>
      <div>
        <span class="menu__label" translate>End date</span>

        <app-datepicker
          [date]="dropDate"
          [height]="'28px'"
          [hasBackdrop]="true"
          (dateChanged)="updateSelectedDate($event, 'end_date')"></app-datepicker>
      </div>
    </div>
    <div class="flex-row row-flex--end mt-1">
      <btn-action
        [uppercase]="true"
        [styleClasses]="'black-light mr-1 border--none'"
        [buttonLabel]="'Cancel' | translate"
        (applyAction)="closeMenu()">
      </btn-action>

      <btn-action
        [buttonLabel]="dragData?.title || 'Save' | translate"
        [styleClasses]="'border--none'"
        [uppercase]="true"
        [withIcon]="(updateProjectItem?.loadingCrud$ | async).updating"
        [showLoadingIcon]="(updateProjectItem?.loadingCrud$ | async).updating"
        (applyAction)="saveChangesToProject()">
      </btn-action>

      <create-subproject-btn-tile
        additionalClass="action-btn--white"
        [small]="true"
        (submitAction)="saveChangesToProject(true)"></create-subproject-btn-tile>
    </div>
  </div>
</ng-container>
